/* Keyboard/focus upgrade for the CSS-checkbox "Supplement Facts" lightboxes
   (fig-support, fig-howto, ag-science, ag-standards — their toggle inputs carry
   data-ag-lightbox). Progressive enhancement: without JS the pattern still works
   with a mouse exactly as before.
   Adds: Enter/Space activation on the <label> openers/closers (labels aren't
   natively activatable), Escape-to-close, focus moved to the dialog's close
   button on open and restored on close, and a Tab trap while open — so the
   declared role="dialog" aria-modal="true" is actually true for keyboard users.
   Uses event delegation + a shopify:section:load re-run so it survives theme
   editor section reloads. */
(function () {
  var SEL = 'input[type="checkbox"][data-ag-lightbox]';

  /* Make every non-backdrop label that controls a lightbox toggle focusable and
     button-announced. Backdrop labels stay click-only (out of the tab order). */
  function upgrade() {
    document.querySelectorAll(SEL).forEach(function (toggle) {
      document.querySelectorAll('label[for="' + toggle.id + '"]').forEach(function (label) {
        if (label.className.indexOf('backdrop') !== -1) return;
        if (!label.hasAttribute('tabindex')) label.setAttribute('tabindex', '0');
        if (!label.hasAttribute('role')) label.setAttribute('role', 'button');
      });
    });
  }

  function dialogFor(toggle) {
    return toggle.parentElement ? toggle.parentElement.querySelector('[role="dialog"]') : null;
  }

  function closeBtnFor(toggle) {
    var dialog = dialogFor(toggle);
    if (!dialog) return null;
    var labels = dialog.querySelectorAll('label[for="' + toggle.id + '"]');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].className.indexOf('backdrop') === -1) return labels[i];
    }
    return null;
  }

  var lastFocus = null;

  document.addEventListener('change', function (e) {
    var toggle = e.target;
    if (!toggle.matches || !toggle.matches(SEL)) return;
    if (toggle.checked) {
      lastFocus = document.activeElement;
      var close = closeBtnFor(toggle);
      if (close) close.focus();
    } else if (lastFocus) {
      lastFocus.focus();
      lastFocus = null;
    }
  });

  document.addEventListener('keydown', function (e) {
    /* Enter/Space on a focused lightbox label = click it (toggles the checkbox). */
    var t = e.target;
    if ((e.key === 'Enter' || e.key === ' ') && t && t.tagName === 'LABEL' && t.htmlFor) {
      var control = document.getElementById(t.htmlFor);
      if (control && control.matches && control.matches(SEL)) {
        e.preventDefault();
        t.click();
        return;
      }
    }

    var open = null;
    document.querySelectorAll(SEL).forEach(function (tg) { if (tg.checked) open = tg; });
    if (!open) return;

    if (e.key === 'Escape') {
      open.checked = false;
      open.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (e.key === 'Tab') {
      var dialog = dialogFor(open);
      if (!dialog) return;
      var focusables = dialog.querySelectorAll('label[tabindex="0"], a[href], button:not([disabled]), [tabindex="0"]');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgrade);
  } else {
    upgrade();
  }
  document.addEventListener('shopify:section:load', upgrade);
})();
